function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 152,
  height: 152,
  rx: 20,
  ry: 20
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M103.82 156H80V99.69H68V80h12V68.4C80 52.46 86.15 43 104.76 43h15.49v19.52h-9.68c-7.25 0-6.57 2.73-6.57 7.83V80h16.36l-2.05 19.69h-14.49z"
});

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgFacebook;